import templateUrl from './content-card.html';

export const contentCardComponent = {
	bindings: {
		id: '@',
		type: '@',
		card: '<',
		componentName :'@',
		title: '@',
		coverPicUrl: '@',
		onEdit: '&',
		onPreview: '&',
		date: '<',
		description: '@',
		isClampDescription: '@',
		hideIfImageUnavailable: '@',
		link: '@',
		pdf:'@',
		downloadUrl:'@',
		pdfName:'@'
	},
	templateUrl,
	controller: class ContentCardComponent {
		constructor(Constants, $parse) {
			'ngInject';

			this.$parse = $parse;
		}
		$onInit() {
			this._hideIfImageUnavailable = this.$parse(this.hideIfImageUnavailable || 'true')(true);
		}

		_onEdit(id) {
			this.onEdit({id});
		}

		_onPreview(id) {
			this.onPreview({id});
		}
	}
};



// WEBPACK FOOTER //
// ./src/app/common/components/content-card/content-card.component.js